import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { LogoProvider } from './LogoProvider';
import * as iconSources from './iconSources';
import { HttpClient } from '@wix/http-client';
export var PurchasedProvider = /*#__PURE__*/function (_LogoProvider) {
  _inheritsLoose(PurchasedProvider, _LogoProvider);

  function PurchasedProvider(source) {
    var _this;

    _this = _LogoProvider.call(this, source || iconSources.PURCHASED_SOURCE) || this;
    _this._httpClient = new HttpClient();
    return _this;
  }

  var _proto = PurchasedProvider.prototype;

  _proto.getSVG = function getSVG(_ref) {
    var iconUrl = _ref.iconUrl;
    return this._httpClient.get(iconUrl, {
      disableWixHeaders: true
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.searchIcons = /*#__PURE__*/function () {
    var _searchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", null);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function searchIcons() {
      return _searchIcons.apply(this, arguments);
    }

    return searchIcons;
  }();

  _proto.getIconById = function getIconById(id) {
    return {
      id: id,
      iconUrl: "https://images-wixmp-fe53c9ff592a4da924211f23.wixmp.com/esh/icon_defaults/noun_" + id + ".svg"
    };
  };

  return PurchasedProvider;
}(LogoProvider);